import { createAction, props } from '@ngrx/store';

import type { Timeslot } from './get-timeslots.reducers';

const prefix = '[Sustainability Timeslots]';

export const loadTimeslots = createAction(`${prefix} Load`);

export const clearTimeslots = createAction(`${prefix} Clear`);

export const receivedTimeslotsForDay = createAction(
  `${prefix} Received timeslots for a day`,
  props<{ day: string; timeslots: Timeslot[] }>()
);

export const loadTimeslotsError = createAction(`${prefix} Error`);

export const setTimeslotDay = createAction(
  `${prefix} Set timeslot day`,
  props<{ day: string }>()
);
